<style lang="scss" scoped>
.wrapper {
  z-index: 1;
}

.container {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  height: 100%;
  width: 100%;
  padding: 0 10px;
}

hr {
  border: 1px solid var(--color-background);
  /*border-top: 1px double darkgray;*/
  border-top: none;
  /*color: #333;*/
  overflow: visible;
  text-align: center;
  height: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.table-header {
  position: sticky;
  top: 0;
  height: 42px;

  &_border {
    margin-bottom: 2px;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: 0px;
  }
}

.coin-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.header-column {
  $dur: 0.1s;
  $base-transition: $dur (2 * $dur);

  text-align: left;
  opacity: 1;
  padding: 0px 3px;
  font-size: 12px;
  transition: font-size $base-transition, padding $base-transition,
    opacity (2 * $dur) (3 * $dur);

  &.fold {
    opacity: 0;
    font-size: 0;
    padding: 0;
    transition: 0s;
  }
}

.table-wrapper {
  margin-right: -10px;
  overflow: auto;
}

.tablerow {
  background-color: var(--color-card-dark);
}

.oddrow {
  background-color: var(--color-card);
}

.red {
  color: var(--color-danger-light);
  /*color: orangered;*/
}

.green {
  color: var(--color-success-light);
}

.point {
  cursor: pointer;
}

td {
  /*border: 1px dotted lightpink;*/
}

div {
  /*border: 1px dotted lightyellow;*/
}

img {
  /*border: 1px dotted chartreuse;*/
}

@media all and (min-width: 1200px) and (max-width: 1300px) {
  #asseticon {
    width: 20px;
  }
  #iconcell {
    width: 20px;
  }
  #asset {
    font-size: 12px;
  }
  .text-size {
    font-size: 12px;
  }
}

@media all and (max-width: 1200px) {
  #asseticon {
    width: 32px;
  }
  #iconcell {
    width: 32px;
  }
  #asset {
    font-size: 16px;
  }
  .text-size {
    font-size: 16px;
  }
}

@media all and (min-width: 1300px) {
  #asseticon {
    width: 32px;
  }
  #iconcell {
    width: 32px;
  }
  #asset {
    font-size: 16px;
  }
  .text-size {
    font-size: 14px;
  }
}
</style>

<template>
  <div class="wrapper">
    <div class="box container">
      <table style="width: 100%; border-collapse: collapse; position: relative">
        <tr
          :class="{ 'table-header': advanced }"
          style="
            font-size: 12px;
            font-weight: bold;
            padding-top: 10px;
          "
        >
          <th>
            <MiniAssetSearch
              v-model="search"
              :isShowSearch.sync="isShowSearch"
            />
          </th>
          <th
            class="header-column"
            :class="{fold: isShowSearch}"
            colspan="2"
          >
            <div class="coin-wrapper">
              <span
                class="clickable noselect"
                @click="sortList('coin')"
              >{{$text.tr('МОНЕТА')}}</span>
              <Icon
                v-if="sort.field === 'coin' && sort.direction === 1"
                type="md-arrow-dropup"
              />
              <Icon
                v-if="sort.field === 'coin' && sort.direction === -1"
                type="md-arrow-dropdown"
              />
            </div>
          </th>
          <th
            class="header-column noselect"
            :class="{fold: isShowSearch}"
          >
            {{ $text.tr('БАЛАНС') }}
          </th>
          <th
            class="header-column"
            :class="{fold: isShowSearch}"
            v-if="!mini"
          >
            {{ $text.tr('СТОИМОСТЬ') }}
          </th>
          <th
            class="header-column point"
            :class="{fold: isShowSearch}"
          >
            <div style="
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                      ">
              <span
                class="clickable noselect"
                @click="sortList('value')"
              >{{
                        $text.tr('СТОИМОСТЬ')
                      }}</span>
              <Icon
                v-if="sort.field === 'value' && sort.direction === 1"
                type="md-arrow-dropup"
              />
              <Icon
                v-if="sort.field === 'value' && sort.direction === -1"
                type="md-arrow-dropdown"
              />
              <div
                style="display: inline-block;"
                :style="{width: isShowSearch ? '0px' : '12px'}"
                v-if="sort.field !== 'value'"
              ></div>
            </div>
          </th>
          <th style="text-align: right">
            <MiniAssetRefresher />
          </th>
        </tr>
      </table>
      <hr class="table-header_border" />
      <div class="table-wrapper">
        <table style="width: 100%; border-collapse: collapse; position: relative">
          <template v-for="(asset, index) in searchPairsBalances">
            <tr
              :key="asset.Coin"
              class="tablerow"
              :class="{ oddrow: index % 2 === 0 }"
            >
              <td id="iconcell">
                <div style="display: flex; padding: 0px 5px">
                  <CoinIcon
                    id="asseticon"
                    :symbol="asset.Coin"
                    big
                  />
                </div>
              </td>
              <td style="
                text-align: left;
                padding: 15px 3px;
                vertical-align: center;
              ">
                <div
                  id="asset"
                  style="font-weight: normal; cursor: pointer"
                  v-on:click="selectSymbol(asset.Coin)"
                >
                  {{ asset.Coin }}
                </div>
              </td>
              <td style="text-align: left; padding: 15px 3px">
                <div
                  class="text-size"
                  :class="{ 'blur-balance': $store.state.sys.hideBalances }"
                  :title="$text.tr('Свободный баланс')"
                >
                  <div>{{ asset.Free }}</div>
                </div>
                <div
                  class="text-size"
                  :class="{ 'blur-balance': $store.state.sys.hideBalances }"
                  style="color: darkgray"
                  :title="$text.tr('Зарезервировано')"
                >
                  <div>{{ asset.Locked }}</div>
                </div>
              </td>
              <td style="text-align: right; padding: 15px 3px">
                <div
                  class="text-size"
                  :class="{ 'blur-balance': $store.state.sys.hideBalances }"
                  style="padding-right: 8px"
                  :title="$text.tr('Стоимость')"
                >
                  <div>{{ terminal.usdbtcValue(asset, 'Value') }}</div>
                </div>
              </td>
              <td style="text-align: right">
                <div style="
                  height: 45px;
                  padding-right: 5px;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                ">
                  <Icon
                    v-if="
                        !constants.isStableCoin(asset.Coin) &&
                        (!asset.Coin.includes('-') || $store.state.sys.tradeExchange.ExchId === 'OKX' ||
                        $store.getters.isBYF)
                    "
                    @click="setSltp(asset.Coin)"
                    color="var(--color-text-dark)"
                    style="cursor: pointer"
                    :title="$text.tr('Создать смарт сделку')"
                    type="md-add"
                    size="20"
                  ></Icon>
                  <Icon
                    v-if="
                       !$store.getters.isFutures &&
                        !constants.isStableCoin(asset.Coin)
                    "
                    @click="showPanicSellConfirm(asset)"
                    color="var(--color-text-dark)"
                    style="cursor: pointer"
                    size="18"
                    :title="$text.tr('Продать')"
                    type="logo-usd"
                  ></Icon>
                </div>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
    <AssetPanicSellModal
      :asset="panicSellAsset"
      @on-cancel="$store.state.assetPanicSellModal.show = false"
    />
  </div>
</template>

<script>
import MiniAssetSearch from '@/components/MainPage/Terminal/MiniAssetSearch'
import terminal from '@/services/terminal'
import constants from '@/util/constants'
import MiniAssetRefresher from '@/components/MainPage/Terminal/MiniAssetRefresher'
import AssetPanicSellModal from '../../common/AssetPanicSellModal'
import CoinIcon from '@/components/common/CoinIcon'
import SlimApi from '@/util/slimapi'
import SlimApis from '@/util/slimapis'
import util from '@/util/util'

export default {
  name: 'MiniAssets',
  components: {
    AssetPanicSellModal,
    MiniAssetRefresher,
    CoinIcon,
    MiniAssetSearch
  },
  // mixins: [constants],
  props: {
    mini: Boolean,
    advanced: Boolean
  },
  data: function () {
    return {
      panicSellAsset: '',
      isShowSearch: false,
      search: '',
      sort: {
        direction: 1,
        field: 'coin'
      }
    }
  },
  computed: {
    constants () {
      return constants
    },
    terminal () {
      return terminal
    },
    pairsBalances: function () {
      // return []
      let list = []
      // console.log('assets data: ', this.$store.state.assets.data)
      if (this.$store.state.assets.data) {
        this.$store.state.assets.data.forEach(item => {
          //   item.buyCost = parseFloat((parseFloat(item.PriceUSD) * parseFloat(item.Qty)).toFixed(2))
          list.push(item)
        })
        // list = this.$store.state.assets.data
      }
      list = list.filter(item => parseFloat(item.Value.U) > 1.0 || item.Coin.includes(')'))
      list.sort((a, b) => {
        let direction = 1
        switch (this.sort.field) {
          case 'coin':
            direction = a.Coin > b.Coin ? 1 : -1
            break
          case 'value':
            direction = parseFloat(a.Value.U) > parseFloat(b.Value.U) ? 1 : -1
            break
        }
        return this.sort.direction * direction
      })

      return list
    },
    searchPairsBalances () {
      const result = []

      this.pairsBalances.forEach(item => {
        const index = item.Coin.indexOf(this.search.toUpperCase())

        if (index !== -1) {
          result.push({
            ...item,
            searchIndex: index
          })
        }
      })

      return result.sort((a, b) => a.searchIndex - b.searchIndex)
    }
  },
  watch: {
    // '$store.state.texchange': function () {
    //   this.updateBalance()
    // },
    // '$store.state.lastTrade': function () {
    //   this.updateBalance()
    // },
    // '$store.state.tradesymbol': function () {
    //   if (!this.$store.state.tradesFilter.allpairs) {
    //     this.updateBalance()
    //   }
    // }
  },
  methods: {
    showPanicSellConfirm (asset) {
      this.panicSellAsset = asset
      this.$store.state.assetPanicSellModal.show = true
    },
    sortList: function (field) {
      this.sort.field = field
      this.sort.direction = -1 * this.sort.direction
    },
    setSltp: function (asset) {
      // console.log(asset)

      if (asset.includes(')')) {
        // console.log('FUT SMART SELL')

        let url1 = 'trade/create?token=' + this.$store.state.sys.token + '&etid=' + this.$store.state.sys.tradeExchange.Id
        url1 += '&symbol=' + asset
        url1 += '&otype=okxfutsmartsell'

        const ref = this
        SlimApis[util.exchId2sputnik(this.$store.state.sys.tradeExchange.ExchId)].get(url1)
          .then((response) => {
            // console.log('response:', response.data)
            if (!response.data.err) {
              ref.$Notice.success({
                title: ref.$text.tr('Сделка создана'),
                duration: 6
              })
              this.$store.state.sys.lastTrade = Date.now()
            } else {
              // ref.$Message.error('Ошибка: ' + response.data.err)
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          })
          .catch(function (error) {
            console.log(error)
            ref.$Message.error(ref.$text.tr('Ошибка'))
          })

        return
      }

      const index = this.$store.state.assets.data.findIndex(function (item) {
        return item.Coin === asset
      })
      this.$store.state.sltpIndex = index
      this.$store.state.sltpTrade = false
      this.$store.state.sltpModal = true
      // this.$store.dispatch('showSlTp')
    },
    selectSymbol (asset) {
      if (
        !this.$store.state.trade.tvEnabled &&
        this.$store.state.trade.tvLoading
      ) {
        // console.log('tv not loaded. ignore symbol change')
        return
      }

      const i = asset.indexOf(' (')
      if (i > 0) {
        asset = asset.substring(0, i)
      }

      // console.log(this.$store.state.data.symbolsfilter)
      const quoteSymbol = this.$store.state.sys.tradeExchange.ExchId === 'FTX' ? '_USD' : '_USDT'
      const symbols = this.$store.state.data.symbolsfilter
      let symbol = asset + quoteSymbol

      if (!symbols[symbol]) {
        symbol = asset + '_BTC'
      }
      if (constants.stables[asset]) {
        symbol = 'BTC_' + asset
      }
      this.$store.state.trade.editTradeId = null
      this.$store.state.trade.editTrade = null
      terminal.selectSymbol(symbol)
      this.$bus.$emit('filterTrades')
    }
  }
}
</script>
